// update user subscription
import { useStoreApi } from '@givebacks/api/store';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { Subscription, UpdatePaymentOnSubscription } from '../../../../../new/types';

export const useUpdateUserSubscription = () => {
  const StoreApi = useStoreApi();
  const queryClient = useQueryClient();

  const updateUserSubscription = async ({
    subscription_uuid,
    subscription,
  }: {
    subscription_uuid: string;
    subscription: Partial<Subscription>;
  }): Promise<Subscription> => {
    const { data } = await StoreApi.put(`/subscriptions/${subscription_uuid}`, { subscription });

    return data.subscription;
  };

  return useMutation({
    mutationFn: updateUserSubscription,
    onSuccess() {
      return queryClient.invalidateQueries({
        queryKey: ['user', 'store', 'subscriptions', 'active'],
      });
    },
  });
};

export const useUpdateUserSubscriptionPaymentMethod = () => {
  const StoreApi = useStoreApi();
  const queryClient = useQueryClient();

  const updateUserSubscription = async ({
    subscription_uuid,
    subscription,
  }: {
    subscription_uuid: string;
    subscription: Partial<UpdatePaymentOnSubscription>;
  }): Promise<Subscription> => {
    const { data } = await StoreApi.put(`/subscriptions/${subscription_uuid}`, { subscription });

    return data.subscription;
  };

  return useMutation({
    mutationFn: updateUserSubscription,
    onSuccess(data) {
      return queryClient.invalidateQueries({
        queryKey: ['user', 'store', 'subscriptions', data.uuid],
      });
    },
  });
};

// cancel cart subscription
// cancel user subscription
